<template>
  <div>
    <v-app-bar app color="primary" dark>
      <v-container class="d-flex align-center justify-space-between">
        <v-img
          src="@/assets/logo.png"
          max-height="40"
          max-width="40"
          contain
        />

        <div class="d-md-none d-flex justify-center">
          <v-menu bottom offset-x>
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" text>
                {{ activePage }} <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                to="/"
                exact
                link
                :class="{ 'navbar-active': $route.path === '/' }"
              >
                <v-list-item-title>Ana Sayfa</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/announcements"
                link
                :class="{ 'navbar-active': $route.path === '/announcements' }"
              >
                <v-list-item-title>Duyurular</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/news"
                link
                :class="{ 'navbar-active': $route.path === '/news' }"
              >
                <v-list-item-title>Haberler</v-list-item-title>
              </v-list-item>
              <v-list-item
                to="/educations"
                link
                :class="{ 'navbar-active': $route.path === '/educations' }"
              >
                <v-list-item-title>Eğitimler</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div class="d-none d-md-flex">
          <v-spacer></v-spacer>
          <v-btn
            text
            to="/"
            exact
            :class="{ 'navbar-active': $route.path === '/' }"
            >Ana Sayfa</v-btn
          >
          <v-btn
            text
            to="/announcements"
            :class="{ 'navbar-active': $route.path === '/announcements' }"
            >Duyurular</v-btn
          >
          <v-btn
            text
            to="/news"
            :class="{ 'navbar-active': $route.path === '/news' }"
            >Haberler</v-btn
          >
          <v-btn
            text
            to="/educations"
            :class="{ 'navbar-active': $route.path === '/educations' }"
            >Eğitimler</v-btn
          >
          <v-spacer></v-spacer>
        </div>

        <div class="d-none d-md-flex align-center">
          <template v-if="!isAuthenticated">
            <v-btn text to="/login">Giriş Yap</v-btn>
            <v-btn text to="/register">Kayıt Ol</v-btn>
          </template>
          <template v-else>
            <v-btn text to="/announcements/new" icon>
              <v-icon>mdi-plus-box</v-icon>
              <v-tooltip activator="parent" location="bottom">Yeni İlan</v-tooltip>
            </v-btn>
            <v-btn text to="/favorites" icon>
              <v-icon>mdi-heart</v-icon>
              <v-tooltip activator="parent" location="bottom">Favoriler</v-tooltip>
            </v-btn>
            <v-btn text icon>
              <v-badge content="3" color="error">
                <v-icon>mdi-bell</v-icon>
              </v-badge>
              <v-tooltip activator="parent" location="bottom">Bildirimler</v-tooltip>
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ props }">
                <v-btn text v-bind="props">
                  <v-icon left>mdi-account</v-icon>
                  {{ currentUser?.username }} <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list density="compact">
                <v-list-item to="/profile">
                  <v-list-item-title>Profil</v-list-item-title>
                  <template v-slot:prepend><v-icon>mdi-account-circle</v-icon></template>
                </v-list-item>
                <v-list-item to="/messages">
                  <v-list-item-title>Mesajlar</v-list-item-title>
                  <template v-slot:prepend><v-icon>mdi-email</v-icon></template>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout">
                  <v-list-item-title>Çıkış Yap</v-list-item-title>
                  <template v-slot:prepend><v-icon color="error">mdi-logout</v-icon></template>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </div>

        <div class="d-md-none">
          <v-btn icon @click="toggleDrawer">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </div>
      </v-container>
    </v-app-bar>

    <v-navigation-drawer :model-value="drawer" temporary fixed right @update:model-value="updateDrawer">
      <v-list>
        <v-list-item v-if="!isAuthenticated" to="/login" link>
          <v-list-item-title>Giriş Yap</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!isAuthenticated" to="/register" link>
          <v-list-item-title>Kayıt Ol</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-if="isAuthenticated" to="/announcements/new" link>
          <template v-slot:prepend><v-icon>mdi-plus-box</v-icon></template>
          <v-list-item-title>Yeni İlan</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAuthenticated" to="/favorites" link>
          <template v-slot:prepend><v-icon>mdi-heart</v-icon></template>
          <v-list-item-title>Favoriler</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAuthenticated" to="/notifications" link>
          <template v-slot:prepend><v-badge content="3" color="error"><v-icon>mdi-bell</v-icon></v-badge></template>
          <v-list-item-title>Bildirimler</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAuthenticated" to="/profile" link>
          <template v-slot:prepend><v-icon>mdi-account-circle</v-icon></template>
          <v-list-item-title>Profil</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAuthenticated" to="/messages" link>
          <template v-slot:prepend><v-icon>mdi-email</v-icon></template>
          <v-list-item-title>Mesajlar</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isAuthenticated" @click="logout">
          <template v-slot:prepend><v-icon color="error">mdi-logout</v-icon></template>
          <v-list-item-title>Çıkış Yap</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'NavbarComponent',
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'currentUser']),
    activePage() {
      switch (this.$route.path) {
        case '/':
          return 'Ana Sayfa';
        case '/announcements':
          return 'Duyurular';
        case '/news':
          return 'Haberler';
        case '/educations':
          return 'Eğitimler';
        default:
          return 'Sayfalar'; // Bir eşleşme olmazsa varsayılan olarak "Sayfalar" gösterebilirsiniz.
      }
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),
    toggleDrawer() {
      this.$emit('toggle-drawer');
    },
    updateDrawer(value) {
      this.$emit('update:drawer', value);
    },
  },
};
</script>

<style scoped>
/* Navbar'a özel stiller */
.v-btn {
  margin: 0 4px;
}

.navbar-active {
  font-weight: bold;
}
</style>